export function calculateLcoe({ capex, annualMWh, siteAreaHa, kWp }, params = {}) {
  const {
    landCostPerHa = 0,
    oAndMPerKwp = 0,
    financingRate = 0.0,
    annualDegradation = 0.0,
    lifetimeYears = 25,
  } = params;

  const annualEnergy = annualMWh * 1000; // to kWh
  const annualOpCost = oAndMPerKwp * kWp + landCostPerHa * siteAreaHa;

  let npvCost = capex;
  let npvEnergy = 0;

  for (let year = 1; year <= lifetimeYears; year++) {
    const discount = Math.pow(1 + financingRate, year);
    const energyThisYear = annualEnergy * Math.pow(1 - annualDegradation / 100, year - 1);
    npvCost += annualOpCost / discount;
    npvEnergy += energyThisYear / discount;
  }

  const lcoe = npvEnergy > 0 ? npvCost / npvEnergy : 0;
  return { lcoe, npvCost, npvEnergy, annualOpCost };
}

export default calculateLcoe;
